import React from 'react';
import { Navigate } from 'react-router-dom';

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const accessToken = localStorage.getItem('access-token');

  if (accessToken) {
    // If user is logged in, redirect to products page
    return <Navigate to="/products" replace />;
  }

  return <>{children}</>;
};

export default PublicRoute; 